/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { loadReportingFrameworksByPrimaryConnections } from '../../actions/reportingFrameworks';
import Loader from '../../components/loader';
import { useAppDispatch, useAppSelector } from '../../reducers';
import SDGAP from './SDGAP';
import { sdgGapPrimaryRoute } from './SdgapRoute';

const PrimaryConnections = () => {

  const dispatch = useAppDispatch();
  const frameworks = useAppSelector((state) => state.reportingFrameworks);

  React.useEffect(() => {
    dispatch(loadReportingFrameworksByPrimaryConnections());
  }, [dispatch]);

  if (!frameworks.loaded || frameworks.reportType !== 'primary-connections') {
    return <Loader />
  }
  return <SDGAP
    route={sdgGapPrimaryRoute}
  />;
}

export default PrimaryConnections;
